export default "__VITE_ASSET__4560ee5f__"